/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import AgGrid from 'DesignSystem/AgGrid/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/AppliedPayments/Content",
  columnDefs
  
}) {
let appliedPaymentsValueData = fromData.useDataValue({ viewPath,
context: 'applied_payments',
})
  return (<React.Fragment
>
<AgGrid
  viewPath={`${viewPath}/AgGrid`}
 height="100%"
 columnDefs={columnDefs}
 data="applied_payments"
 rowData={appliedPaymentsValueData}
 rowGroupPanelShow="never"
/>
{children}
</React.Fragment>)
}